export default function ComplianceBanner() {
  return (
    <div className="compliance-strip py-2.5 text-center px-4" data-testid="compliance-banner">
      For research use only — not for human or veterinary use
    </div>
  );
}
